import { useCallback } from 'react';
import { useDialog } from '@workspace/design-system/src/components';
import type { PlanInquiryResponseModel } from '@src/models/enterprise-inquiry';
import { EnterpriseInquiryModal } from '@src/pages/Studio/EnterpriseInquiry/EnterpriseInquiryModal';

export function useEnterpriseInquiryModals() {
  const { openDialog, closeDialog } = useDialog();

  const openDetailModal = useCallback(
    (inquiry: PlanInquiryResponseModel) => {
      openDialog(
        <EnterpriseInquiryModal
          inquiry={inquiry}
          isOpen={true}
          onClose={closeDialog}
          onSave={async (updatedInquiry) => {
            // 저장 로직은 모달 내부에서 처리
            closeDialog();
          }}
        />
      );
    },
    [openDialog, closeDialog]
  );

  return {
    openDetailModal,
  };
}

